console.log("low-stock.js loaded");

document.addEventListener("DOMContentLoaded", () => {
  const lowStockScript = document.getElementById('LowStockJson');
  const lowStockEl = document.getElementById('low-stock');
  const quantityInput = document.getElementById('Quantity-product-template');

  if (!lowStockScript || !lowStockEl || !quantityInput) return;

  const lowStockVariants = JSON.parse(lowStockScript.textContent);

  function updateLowStock() {
    let variant;

    // Check if there are variant radios
    const selectedOptions = Array.from(document.querySelectorAll('.single-option-selector-product-template:checked'))
      .map(input => input.value.trim());

    if (selectedOptions.length) {
      // Combine selected options into a single string like in the JSON
      const selectedTitle = selectedOptions.join(' / ');
      variant = lowStockVariants.find(v => v.title === selectedTitle);
    } else if (lowStockVariants.length === 1) {
      // Single product, no variant selectors
      variant = lowStockVariants[0];
    }

    if (variant && variant.qty > 0) {
      lowStockEl.innerHTML = `<p style="margin:0;">Only <span>${variant.qty}</span> left!</p>`;
      quantityInput.setAttribute('max', variant.qty);
    } else if (variant && variant.qty == 0) {
      lowStockEl.innerHTML = `<p style="margin:0;">Sold out!</p>`;
      quantityInput.setAttribute('max', 0);
    }
    else {
      lowStockEl.innerHTML = '';
      quantityInput.removeAttribute('max');
    }
  }

  // Initial load
  updateLowStock();

  // Listen for changes on variant radio buttons (if any)
  const variantInputs = document.querySelectorAll('.single-option-selector-product-template');
  variantInputs.forEach(input => input.addEventListener('change', updateLowStock));
});